import { bus_monitoring } from "../../../models/response/bus/bus_monitoring";
import {
	eBusMonitoringActionTypeIds,
	IBusMonitoringChangeSelectedIds,
	IBusMonitoringCloseConfirm,
	IBusMonitoringCloseDetail,
	IBusMonitoringDeleteErr,
	IBusMonitoringDeleteStart,
	IBusMonitoringDeleteSuccess,
	IBusMonitoringLoadErr,
	IBusMonitoringLoadStart,
	IBusMonitoringLoadSuccess,
	IBusMonitoringSaveErr,
	IBusMonitoringSaveStart,
	IBusMonitoringSaveSuccess,
	IBusMonitoringShowConfirm,
	IBusMonitoringShowDetail
} from "../../action-types/bus/IBusMonitoringActionTypes";

export const busMonitoringActions = {
	loadBusMonitoringStart: (dm_coso_id: number): IBusMonitoringLoadStart => {
		return {
			type: eBusMonitoringActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadBusMonitoringSuccess: (data: bus_monitoring[]): IBusMonitoringLoadSuccess => {
		return {
			type: eBusMonitoringActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusMonitoringError: (message: string): IBusMonitoringLoadErr => {
		return {
			type: eBusMonitoringActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showBusMonitoringDetail: (data?: bus_monitoring): IBusMonitoringShowDetail => {
		return {
			type: eBusMonitoringActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusMonitoringDetail: (): IBusMonitoringCloseDetail => {
		return {
			type: eBusMonitoringActionTypeIds.CLOSE_DETAIL
		}
	},
	showBusMonitoringConfirm: (): IBusMonitoringShowConfirm => {
		return {
			type: eBusMonitoringActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusMonitoringConfirm: (): IBusMonitoringCloseConfirm => {
		return {
			type: eBusMonitoringActionTypeIds.CLOSE_CONFIRM
		}
	},
	changeBusMonitoringSelectedIds: (ids: number[]): IBusMonitoringChangeSelectedIds => {
		return {
			type: eBusMonitoringActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	deleteBusMonitoringStart: (id: number): IBusMonitoringDeleteStart => {
		return {
			type: eBusMonitoringActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusMonitoringSuccess: (): IBusMonitoringDeleteSuccess => {
		return {
			type: eBusMonitoringActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusMonitoringErr: (message: string): IBusMonitoringDeleteErr => {
		return {
			type: eBusMonitoringActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveBusMonitoringStart: (data: bus_monitoring): IBusMonitoringSaveStart => {
		return {
			type: eBusMonitoringActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusMonitoringSuccess: (): IBusMonitoringSaveSuccess => {
		return {
			type: eBusMonitoringActionTypeIds.SAVE_SUCCESS
		}
	},
	saveBusMonitoringError: (message: string): IBusMonitoringSaveErr => {
		return {
			type: eBusMonitoringActionTypeIds.SAVE_ERR,
			payload: message
		}
	}
}
